import { Map as ImmutableMap } from 'immutable';
import { call, put, take, takeLeading } from 'redux-saga/effects';
import { v4 as uuid } from 'uuid';

import { resourceSagaUtils, resourceStoreTypes } from 'app-components/flux/core';
import { getEnvironmentConfig, getLogger, httpClientInterface } from 'app-components/utils/core';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

// local
import * as actions from './billerAccountsActions';
import { transformResponseToBillerAccounts } from './billerAccountsTransformers';

const log = getLogger('data/billerAccounts/sagas');

// =============================================================================
// Biller Account Get Saga Functions
// =============================================================================

const mkResourceConfig = (props) =>
  resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'biller acconts',
    resourceBaseUrl: '/billpresentment/billeraccounts',
    // getLastSyncDate, // don't query by lastSyncDate to make sure we get all updated accounts
    transformResourceToRequestData: (resource) => ({
      ...(resource.toJS ? resource.toJS() : resource),
    }),
    transformResponseToResources: transformResponseToBillerAccounts,
    ...props,
  });

export function* getBillerAccountsByLoginId(action) {
  const { loginId, props } = action.payload;

  log.log('Get Account for LoginId:', loginId);

  const requestUrl = `${
    getEnvironmentConfig().services_url
  }/billpresentment/billeraccounts?query=%28billerLoginID%3D%3D%22${loginId}%22%29`;

  try {
    const response = yield call(httpClientInterface.send, 'GET', requestUrl);
    log.log('Found account for Login, response=', response.data);
    const billerAccounts = transformResponseToBillerAccounts(response);
    yield put(
      actions.getBillerAccountsSuccess(resourceStoreTypes.mkQcsSyncResourcesPayload({ resources: billerAccounts }), {
        loginId,
        props,
      }),
    );
  } catch (exceptionError) {
    log.log('Received error', exceptionError);
    yield put(actions.getBillerAccountsFailure(exceptionError));
  }
}

export function* getBillerAccountsSuccessActionWatcher() {
  while (true) {
    const action = yield take(actions.getBillerAccountsSuccess);
    if (action.meta?.props?.discoverFlow) {
      // Biller discovery in progress, show account dialog.
      const billerDiscoveryAccountsDialogData = rootUiTypes.mkRootUiData({
        id: uuid(),
        type: 'DIALOG_TYPE_BILLER_DISCOVERY',
        props: ImmutableMap({
          ...(action.meta?.props || {}),
          billerLoginId: action.meta?.loginId,
          step: 'ACCOUNTS',
        }),
      });

      log.info('Triggering Biller Discovery accounts dialog');
      yield put(rootUiActions.createDialog(billerDiscoveryAccountsDialogData));
    }
  }
}

export function* getBillerAccountsActionWatcher() {
  const resourceConfig = mkResourceConfig({
    successAction: actions.getBillerAccountsSuccess,
    failureAction: actions.getBillerAccountsFailure,
  });
  yield takeLeading(actions.getBillerAccounts, resourceSagaUtils.qcsSyncGetResources, resourceConfig);
}

export function* getBillerAccountsByLoginIdActionWatcher() {
  yield takeLeading(actions.getBillerAccountsForLoginID, getBillerAccountsByLoginId);
}

export default [
  getBillerAccountsActionWatcher,
  getBillerAccountsByLoginIdActionWatcher,
  getBillerAccountsSuccessActionWatcher,
];
